import axios from 'axios';

export async function fetchAdminMe() {
  const response = await axios.get('/api/v1/admin/me');
  return response.data;
}

export async function fetchAdminUsers() {
  const response = await axios.get('/api/v1/admin/users');
  return response.data;
}

export async function fetchAdminUser(userId) {
  const response = await axios.get(`/api/v1/admin/users/${userId}`);
  return response.data;
}

export async function updateAdminUser(userId, payload) {
  const response = await axios.patch(`/api/v1/admin/users/${userId}`, payload);
  return response.data;
}

export async function disableAdminUser(userId) {
  const response = await axios.post(`/api/v1/admin/users/${userId}/disable`);
  return response.data;
}

export async function enableAdminUser(userId) {
  const response = await axios.post(`/api/v1/admin/users/${userId}/enable`);
  return response.data;
}

export async function deleteAdminUser(userId) {
  const response = await axios.delete(`/api/v1/admin/users/${userId}`);
  return response.data;
}
